import { itrustPayPaymentLogsReducer } from './itrustPayPaymentLogsReducer';
import { itrustPayReducer } from './itrustPayReducer';

const itrustPayReducers = {
  itrustPay: itrustPayReducer,
  itrustPayPaymentLog: itrustPayPaymentLogsReducer,
};

export default itrustPayReducers;